import type { ThemeOptions } from '@mui/material';

declare module '@mui/material/Alert' {
  interface AlertPropsColorOverrides {
    neutral: true;
  }
}

export const alertComponent = {
  //
} as const satisfies NonNullable<ThemeOptions['components']>['MuiAlert'];
